import { FC } from "react";
import { Text } from "~/components/Text";
import { Skeleton } from "~/components/Skeleton";
import { Styled } from "./styled";
import { ListItemProps } from "./types";

export const ListItem: FC<ListItemProps> = ({
  title,
  description,
  isSelected,
  onClick,
  isLoading,
  css,
}) => {
  return (
    <>
      {isLoading ? (
        <Styled.Container data-selected={isSelected} aria-busy="true" data-loading={isLoading}>
          <Skeleton variant="text-4" css={{ width: "70%", mb: "$1" }} />
          <Skeleton variant="text-2" css={{ width: "45%" }} />
        </Styled.Container>
      ) : (
        <Styled.Container data-selected={isSelected} onClick={onClick} css={css}>
          <Styled.Title size="3" as="p">
            {title}
          </Styled.Title>

          {description && (
            <Text variant="primary-dark" size="2">
              {description}
            </Text>
          )}
        </Styled.Container>
      )}
    </>
  );
};

ListItem.displayName = "ListItem";
